module.exports = {
	"major": 201906,
	"minor": 1
};


//////////////////
// WEBPACK FOOTER
// ./src/data/version.json
// module id = 1538
// module chunks = 1